import * as Yup from 'yup';
import { DictHoliday } from '@models';

export function useValidationSchema() {
  return Yup.object<DictHoliday>().shape({
    date: Yup.string().nullable().required(),
  });
}
